module.exports = __webpack_public_path__ + "media/1345ConferenceSpace.475b075a.webm";